import AnimatedFloatButton from '@ifca-root/react-component/src/components/Button/AnimatedFloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import ListAltIcon from '@material-ui/icons/ListAlt'
import UploadIcon from '@material-ui/icons/Publish'
import { ApprovalLogDialog } from 'components/Dialog/ApprovalLogDialog'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  useDeleteAssetMutation,
  useGetCostCentreQuery,
  useGetDocNumTitleQuery,
  useGetFaCategoryDropdownListingQuery,
  useGetFaDepreciationQuery,
  useGetFaLocationQuery,
  useGetFaSourceQuery,
  useGetUomQuery,
  useImportAssetRegistrationExcelMutation,
} from 'generated/graphql'
import { useColorStatusList } from 'helpers/Hooks/useColorStatusList'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import { uuid } from 'uuidv4'
import { AssetRegistrationTemplateForm } from '../AssetsRegistrationImport/AssetRegistrationExcelFn'
import { BatchExcelInput } from '../AssetsRegistrationImport/BatchExcelInput'
/* -------------------------------------------- */
/*            For ACTIVE and APPROVED           */
/* -------------------------------------------- */

export const AssetsRegistrationEntryList = (props: any) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    userList,
    fetchMore,
    setOriginalListing,
    selectedField,
    sortOrder,
    refetch,
    TotalLength,
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  let history = useHistory()
  const { CompanyID }: any = useParams()

  const {
    anchorEl,
    menu,
    handleClick,
    handleClose,
    resetMenu,
  } = useMenuOption()
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const { handlePermDisabled } = usePermissionChecker()
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteAA, setDeleteAA] = useState(false)
  const BatchID = uuid()
  const { handleStatusColor, handleStatusRename } = useColorStatusList()
  const [openWorkFlow, setWorkFlow] = useState(false)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2()

  /* -------------------------------------------- */
  /*                    QUERY                     */
  /* -------------------------------------------- */

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: 'fa_registration' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const docNumChecker = getDocumentNumberHeader?.length === 0

  const [
    ImportAssetExcel,
    { loading: ImportAssetRegistrationExcelLoading },
  ] = useImportAssetRegistrationExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])

      history.push({
        pathname: `/fixed-assets/${CompanyID}/assets-registration/import-asset-registration-validation/${data?.ImportAssetRegistrationExcel}`,
        state: {
          BatchID: data?.ImportAssetRegistrationExcel,
          fileTitle: fileTitle,
        },
      })
    },
  })

  const [deleteAsset, { loading: deleteLoading }] = useDeleteAssetMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
      setDeleteAA(false)
      resetMenu()
    },
    onCompleted: data => {
      if (data?.deleteAsset) {
        setSnackBarMsg(SystemMsgs.deleteRecord())
        setOpenSnackBar(true)
        setDeleteAA(false)
        setOriginalListing([])
        resetMenu()
        fetchMore({
          variables: {
            CompanyID: CompanyID,
            StatusArr: [listStatus],
            take: 30,
            skip: 0,
            searchValue:
              getSearch?.name === '' || getSearch?.name === undefined
                ? undefined
                : getSearch?.name,
            sortField: selectedField === null ? undefined : selectedField,
            sortOrder: sortOrder === null ? undefined : sortOrder,
          },
        })
      }
    },
  })

  const {
    loading: FACategoryListingLoading,
    data: { getFACategoryDropdownListing } = {
      getFACategoryDropdownListing: [],
    },
  } = useGetFaCategoryDropdownListingQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: getFASourceLoading,
    data: { getFASource } = { getFASource: [] },
  } = useGetFaSourceQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: uomLoading,
    error: uomError,
    data: { getUOM } = { getUOM: [] },
  } = useGetUomQuery({
    fetchPolicy: 'network-only',
    variables: { orderByAsc: 'Name' },
  })

  const {
    loading: getFADepreciationLoading,
    data: { getFADepreciation } = { getFADepreciation: [] },
  } = useGetFaDepreciationQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: CostCentreLoading,
    error: CostCentreErrors,
    data: { getCostCentre } = { getCostCentre: [] },
  } = useGetCostCentreQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      IsLastNode: true,
    },
  })

  const {
    loading: getFALocationLoading,
    data: { getFALocation } = { getFALocation: [] },
  } = useGetFaLocationQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },

    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  /* -------------------------------------------- */
  /*                    VARIABLE                  */
  /* -------------------------------------------- */

  const handleDelete = () => {
    if (menu?.ID) {
      deleteAsset({
        variables: {
          fa_asset_id: menu.ID,
        },
      })
    }
  }

  /* -------------------------------------------- */
  /*                    SUBMIT                    */
  /* -------------------------------------------- */

  const onImport = data => {
    // Filter out empty rows
    const filteredData = data?.filter(x => {
      return (
        (x?.asset_card_no && x?.asset_card_no !== '') ||
        (x?.name && x?.name !== '') ||
        x?.registration_date
      )
    })

    ImportAssetExcel({
      variables: {
        BatchID: BatchID,
        CompanyID: CompanyID,
        AssetRegistrationImportInput: filteredData?.map((x, index) => {
          return {
            asset_card_no:
              x?.asset_card_no === null ? null : `${x?.asset_card_no}`,
            registration_date:
              x?.registration_date === null
                ? null
                : new Date(x?.registration_date).toISOString(),
            start_use_date:
              x?.start_use_date === null
                ? null
                : new Date(x?.start_use_date).toISOString(),
            name: x?.name === null ? null : `${x?.name}`,
            fa_category_code:
              x?.fa_category_code === null ? null : `${x?.fa_category_code}`,
            fa_source_name:
              x?.fa_source_name === null ? null : `${x?.fa_source_name}`,
            uom_code: x?.uom_code === null ? null : `${x?.uom_code}`,
            base_original_amount:
              x?.base_original_amount === null
                ? null
                : Number(x?.base_original_amount),
            residual: x?.residual === null ? null : Number(x?.residual),
            residual_value:
              x?.residual_value === null ? null : Number(x?.residual_value),
            unit_price: x?.unit_price === null ? null : Number(x?.unit_price),
            fa_depreciation_method_name:
              x?.fa_depreciation_method_name === null
                ? null
                : `${x?.fa_depreciation_method_name}`,
            depreciation_start_year:
              x?.depreciation_start_year === null
                ? null
                : Number(x?.depreciation_start_year),
            depreciation_start_period:
              x?.depreciation_start_period === null
                ? null
                : Number(x?.depreciation_start_period),
            opening_accumulated_depreciation:
              x?.opening_accumulated_depreciation === null
                ? null
                : Number(x?.opening_accumulated_depreciation),
            opening_depreciation_useful_life:
              x?.opening_depreciation_useful_life === null
                ? null
                : Number(x?.opening_depreciation_useful_life),
            depreciation_utilized_useful_life:
              x?.depreciation_utilized_useful_life === null
                ? null
                : Number(x?.depreciation_utilized_useful_life),
            model_no: x?.model_no === null ? null : `${x?.model_no}`,
            ref_no: x?.ref_no === null ? null : `${x?.ref_no}`,
            remark: x?.remark === null ? null : `${x?.remark}`,
            cost_centre_code:
              x?.cost_centre_code === null ? null : `${x?.cost_centre_code}`,
            department_quantity:
              x?.department_quantity === null
                ? null
                : Number(x?.department_quantity),
            department_uom_code:
              x?.department_uom_code === null
                ? null
                : `${x?.department_uom_code}`,
            fa_location_name:
              x?.fa_location_name === null ? null : `${x?.fa_location_name}`,
            RowNo: index + 2,
          }
        }),
      },
    })
  }

  const isDisabled = handlePermDisabled({
    companyID: CompanyID,
    permEnum: AcctPermission.FixedAssetsAssetsRegistrationCreate,
  })

  const actions = [
    {
      icon: (
        <AddIcon
          onClick={
            !isDisabled
              ? () => {
                  if (docNumChecker) {
                    setOpenSnackBar(true)
                    setSnackBarMsg(SystemMsgs.errorNumberingStructure())
                  } else {
                    history.push(
                      `/fixed-assets/${CompanyID}/assets-registration/add`
                    )
                  }
                }
              : undefined
          }
          style={{
            opacity: isDisabled ? 0.4 : 1,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
        />
      ),
      name: isDisabled ? 'No Permission to Add' : 'Add',
    },
    {
      icon: (
        <UploadIcon
          onClick={
            !isDisabled
              ? () => {
                  if (docNumChecker) {
                    setOpenSnackBar(true)
                    setSnackBarMsg(SystemMsgs.errorNumberingStructure())
                  } else {
                    setOpenFileUpload(true)
                  }
                }
              : undefined
          }
          style={{
            opacity: isDisabled ? 0.4 : 1,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
        />
      ),
      name: isDisabled ? 'No Permission to Upload' : 'Upload excel template',
    },
  ]

  return (
    <>
      {listLoading && <Loading />}
      {deleteLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {ImportAssetRegistrationExcelLoading && <Loading />}
      {FACategoryListingLoading && <Loading />}
      {getFASourceLoading && <Loading />}
      {uomLoading && <Loading />}
      {getFADepreciationLoading && <Loading />}
      {CostCentreLoading && <Loading />}
      {getFALocationLoading && <Loading />}

      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                    sortField:
                      selectedField === null ? undefined : selectedField,
                    sortOrder: sortOrder === null ? undefined : sortOrder,
                  },
                })
              }}
              hasMore={filteredList?.length < TotalLength}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                return (
                  <ListItem key={el?.fa_asset_id || index}>
                    <ListItemText
                      primary={
                        <>
                          {listStatus === 'COMPLETED' ||
                          listStatus === 'REJECTED' ? (
                            <>
                              <span className="desc date-width">
                                {formatDate(el?.registration_date)}
                              </span>
                              <span className="xsTitle flex-space">
                                {el?.DocNo}
                              </span>
                              <span
                                className="xxTitle highlight-text"
                                style={{ color: 'orange' }}
                              >
                                {amtStr(el?.original_net_amount)}
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="desc date-width">
                                {formatDate(el?.registration_date)}
                              </span>
                              <span className={`xsTitle flex-space`}></span>
                              <span
                                className="xxTitle highlight-text"
                                style={{ color: 'orange' }}
                              >
                                {amtStr(el?.original_net_amount)}
                              </span>
                            </>
                          )}
                        </>
                      }
                      secondary={
                        <>
                          <Grid container>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={6}>
                                <span className="desc flex-space">
                                  {el?.asset_card_no}
                                </span>
                              </Grid>
                              <Grid item xs={6} style={{ textAlign: 'right' }}>
                                <span className="desc">
                                  {el?.Category?.name}
                                </span>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            spacing={1}
                            container
                            className="table-content"
                            style={{
                              paddingTop: '5px',
                            }}
                          >
                            <Grid item xs={12}>
                              <span
                                className="desc flex-space"
                                style={{ marginBottom: '-5px' }}
                              >
                                {el?.name}
                              </span>
                            </Grid>
                          </Grid>
                          <Grid container>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={9}>
                                <span className="desc">{el?.remark}</span>
                              </Grid>
                              <Grid
                                item
                                xs={3}
                                container
                                justifyContent="flex-end"
                                alignItems="center"
                              >
                                <span className="desc">
                                  <IconButton
                                    style={{
                                      padding: '0px',
                                      paddingRight: '5px',
                                    }}
                                    className="desc"
                                    onClick={e => {
                                      handleClick(e, el?.fa_asset_id, index, el)
                                      setWorkFlow(true)
                                    }}
                                  >
                                    <ListAltIcon style={{ fontSize: '13px' }} />
                                  </IconButton>
                                </span>
                                <span
                                  className="desc"
                                  style={{
                                    color: `${handleStatusColor(
                                      el?.ApprovalStatus
                                    )}`,
                                  }}
                                >
                                  {handleStatusRename(el?.ApprovalStatus)}
                                </span>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      {listStatus === 'ACTIVE' || listStatus === 'REJECTED' ? (
                        <>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(e, el?.fa_asset_id, index, el)
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton edge="end" aria-label="arrow">
                          <KeyboardArrowRight
                            onClick={() =>
                              history.push({
                                pathname: `/fixed-assets/${CompanyID}/assets-registration/${el?.fa_asset_id}/detail`,
                                state: el,
                              })
                            }
                          />
                        </IconButton>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && <AnimatedFloatButton actions={actions} />}
      </ContentWrapper>

      {listStatus === 'ACTIVE' ? (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsAssetsRegistrationUpdate,
            })}
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-registration/${menu?.obj?.fa_asset_id}/edit`,
                state: menu?.obj,
              })
            }}
          >
            <span className="">Edit</span>
          </MenuItem>
          <MenuItem
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsAssetsRegistrationDelete,
            })}
            onClick={() => setDeleteAA(true)}
          >
            <span>Delete</span>
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsAssetsRegistrationUpdate,
            })}
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-registration/${menu?.obj?.fa_asset_id}/edit`,
                state: { ...menu?.obj, mode: 'resubmit' },
              })
            }}
          >
            <span className="">Resubmit</span>
          </MenuItem>
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteAA}
        setOpenDeleteDialog={setDeleteAA}
        title={'Asset Registration'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        passID={menu?.ID}
      />
      <ApprovalLogDialog
        data={menu}
        setWorkFlow={setWorkFlow}
        openWorkFlow={openWorkFlow}
        moduleName="Asset Registration"
        reset={resetMenu}
        handleClose={() => handleClose()}
      />
      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />

      <BatchExcelInput
        showDupErrors={false}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openFileUpload}
        setOpenUpload={setOpenFileUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        showFooter={false}
        labelDisplay={'Asset Registration'}
        onUploadTemplate={() => {
          onImport(currentData)
          setOpenFileUpload(false)
          localStorage.removeItem('searchFilter')
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={() =>
          onDownloadTemplate({
            name: `Asset Registration Template`,
            workSheetName: `Asset List`,
            headerSetup: AssetRegistrationTemplateForm,
            isHeaderLocked: true,
            defaultHeaderFillStyle: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D3D3D3' },
            },
            defaultHeaderBorderStyle: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            },
            listType: {
              hasCountry: true,
              hasNationality: true,
            },
            extraListData: [
              {
                data: getFACategoryDropdownListing?.map(x => x?.name),
                worksheetName: 'fa_category_code',
                dataType: 'fa_category_code',
              },
              {
                data: getFASource?.map(x => x?.name),
                worksheetName: 'fa_source_name',
                dataType: 'fa_source_name',
              },
              {
                data: getUOM?.map(x => x?.Code),
                worksheetName: 'uom_code',
                dataType: 'uom_code',
              },
              {
                data: getFADepreciation?.map(x => x?.name),
                worksheetName: 'fa_depreciation_method_name',
                dataType: 'fa_depreciation_method_name',
              },
              {
                data: getCostCentre?.map(x => x?.MasterCode),
                worksheetName: 'cost_centre_code',
                dataType: 'cost_centre_code',
              },
              {
                data: getFALocation?.map(x => x?.name),
                worksheetName: 'fa_location_name',
                dataType: 'fa_location_name',
              },
            ],
          })
        }
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: snackBarMessage,
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />
    </>
  )
}
